import {
    Select,
    SelectTrigger,
    SelectContent,
    SelectItem,
    SelectValue,
} from 'components/shadcn/ui/select';
import { useField } from 'formik';

const DeviceTypeDropDown = (props) => {
    const [field, meta] = useField('deviceType');

    return (
        <div className="w-full">
            <Select
                onValueChange={(value) =>
                    field.onChange({ target: { name: field.name, value } })
                }
                value={field.value}
            >
                <SelectTrigger>
                    <SelectValue placeholder="Select a device type" />
                </SelectTrigger>
                <SelectContent>
                    <SelectItem value="Battery System">
                        Battery System
                    </SelectItem>
                    <SelectItem value="NEP Gateway">NEP Gateway</SelectItem>
                </SelectContent>
            </Select>
            {meta.error ? <p className="form-message">{meta.error}</p> : null}
        </div>
    );
};

export default DeviceTypeDropDown;
